import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaSignature,
  FaCogs,
  FaTools,
  FaChartPie,
  FaLock
} from "react-icons/fa";
import styles from "./Menu.module.css";

const modules = [
  {
    id: 1,
    name: "Certificados",
    icon: <FaSignature />,
    path: "/certificados",
    enabled: false,
    badge: "Nuevo"
  },
  {
    id: 2,
    name: "Configuración",
    icon: <FaCogs />,
    path: "/config",
    enabled: false,
    badge: "Próx."
  },
  {
    id: 3,
    name: "Mantenimiento",
    icon: <FaTools />,
    path: "/mantenimiento",
    enabled: false,
    badge: "Próx."
  },
  {
    id: 4,
    name: "Reportes",
    icon: <FaChartPie />,
    path: "/reportes",
    enabled: false,
    badge: "Beta"
  }
];

const Analisis = () => {
  const navigate = useNavigate();

  const handleClick = (mod) => {
    if (mod.enabled) {
      navigate(mod.path);
    }
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Análisis</h1>

      <div className={styles.subtitle}>
        Panel central de herramientas del sistema
      </div>

      <div className={styles.buttonGrid}>
        {modules.map((mod) => (
          <div
            key={mod.id}
            className={`${styles.card} ${
              !mod.enabled ? styles.disabled : ""
            }`}
            onClick={() => handleClick(mod)}
          >
            <div className={styles.badge}>{mod.badge}</div>

            <div className={styles.icon}>
              {mod.enabled ? mod.icon : <FaLock />}
            </div>

            <span className={styles.label}>{mod.name}</span>

            <span className={styles.helper}>
              {mod.enabled
                ? "Ingresar al módulo"
                : "No disponible aún"}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Analisis;
